export const getDefaultState = () => {
  return {
    token: localStorage.getItem('user-token') || null,
    error: null,
    status: null,
    profile: null
  }
}
